
import { Edge } from '@xyflow/react'
import React from 'react'

export const defaultEdgeOptions = {
  type: 'smartBezier',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: '#ffffff',
    opacity: 0.5,
  } as React.CSSProperties,
}

export const getEdgeOptions = (source: string, target: string) => {
  const isTeamMemberToManager = source.startsWith('team-member-') && target.startsWith('manager-')
  const isManagerToDirector = source.startsWith('manager-') && target.startsWith('director-')
  
  let options = {
    ...defaultEdgeOptions,
    type: 'smartBezier',
  }

  if (isTeamMemberToManager || isManagerToDirector) {
    options = {
      ...options,
      style: {
        ...options.style,
        stroke: '#ffffff',
        strokeWidth: 2,
        opacity: 0.5,
      } as React.CSSProperties,
    }
  }

  return options
}

export const validateAndConvertEdges = (edges: any): Edge[] => {
  if (!Array.isArray(edges)) return []
  
  return edges.filter((edge): edge is Edge => {
    return (
      typeof edge === 'object' &&
      edge !== null &&
      typeof edge.id === 'string' &&
      typeof edge.source === 'string' &&
      typeof edge.target === 'string'
    )
  })
}
